module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afoot53-15ffa51c485c80c55c2a0777e11f9f22.jpg";